import { createFileRoute } from '@tanstack/react-router';
import { Notes } from '@/components/Modules/Notes';

export const Route = createFileRoute('/notes')({
  component: Notes,
});
